/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

const Routes = {
  LOGIN: '/login',
  SECURITY_CODE: '/security-code',
  FORGOTPASSWORD: '/forgot-password',
  CHANGEPASSWORD: '/change-password',
  HOME: '/home',
  LIST: '/list',
  LIST2: '/list2',
  QUOTATION: '/quote',
  TEST1: '/test1',
  TEST2: '/test2',
  POLICY: '/policy',
  PAYMENT: '/payment',
  RENEW: '/renew',
  ENQUIRIES: '/enquiries',
  CREATEENQUIRITY: '/create-enquirity/:idProduct/:idOperationParent?',
  CREATEMASTERPOLICY: '/create-master-policy/:idProduct',
  EDITMASTERPOLICY: '/edit-master-policy/:idProduct/:idOperation',
  EDITENQUIRITY: '/edit-enquirity/:idProduct/:idOperation/:idOperationParent?',
  POLICIES: '/policies',
  CLAIMS: '/claims',
  CREATECLAIM: '/create-claim',
  EDITCLAIM: '/edit-claim/:idOperation',
  CLAIM_COMPOSITION: '/claim-composition/:idOperation?',
  CLAIM_FDO: '/claim-fdo/:idOperation?',
  PAYMENTS: '/payments',
  RENEWALS: '/renewals',
  NBIREQUEST: '/broking/nbi-request/:idOperation',
  NBIREQUESTCLIENT: '/broking/nbi-request-cv/:idOperation',
  APPROVALNBI: '/broking/approval-nbi/:idOperation',
  APPROVALNBICLIENT: '/broking/approval-nbi-cv/:idOperation',
  SELECTMARKETS: '/broking/select-markets/:idOperation',
  SELECTMARKETSMASTERPOLICY: '/broking/select-markets/:idOperation/:idProduct',
  CONTACTSSELECTION: '/broking/contacts-selection/:idOperation',
  SENDNBIREQUEST: '/broking/send-nbi-request/:idOperation',
  RESENDNBIREQUEST: '/broking/resend-nbi-request/:idOperation/:idPersonInsurer',
  MARKETMANAGEMENT: '/broking/market-selection/:idOperation',
  SCHEDULEEXPORT: '/broking/schedule-export/:idOperation',
  DOCUMENTNBISTATUS: '/broking/document-nbi-status/:idOperation',
  APPROVEDNBI: '/broking/approved-nbi/:idOperation',
  SENDAPPROVALPOLICYPACK: '/broking/send-approval-pack/:idOperation',
  APPROVALPOLICYPACK: '/broking/approval-policy-pack/:idOperation/:idPerson?',
  MARKETCOMPOSITION: '/broking/market-composition/:idOperation',
  MARKETCOMPOSITIONOLD: '/broking/market-composition-v1/:idOperation',
  MARKETCOMPOSITIONUPDATEDSCHEDULE: '/broking/market-composition-updated-schedule/:idOperation',
  SCHEDULEEXIBITIONUPDATEDSCHEDULE: '/broking/schedule-exibition-updated-schedule/:idOperation',
  MRCCOMPLEMENTARY: '/broking/mrc-complementary/:idOperation',
  SENDMRCREQUEST: '/broking/send-mrc-request/:idOperation',
  SENDNBI: '/broking/send-nbi-cv/:idOperation',
  SCHEDULEEXIBITION: '/broking/schedule-exibition/:idOperation',
  SENDPOLICYPACKCLIENT: '/broking/send-policy-pack-client/:idOperation',
  SENDPOLICYPACKINSURER: '/broking/send-policy-pack-insurer/:idOperation',
  POLICYPACKAAPPROVALLIST: '/broking/policy-pack-approval/:idOperation',
  POLICYPACKAPPROVE: '/broking/policy-pack-approve/:idOperation',
  SENDWORDINGREQUEST: '/broking/send-wording-request/:idOperation',
  POLICYPACKDECLARATION: '/broking/send-approval-pack-declaration/:idOperation',
  APPROVALWORDINGCV: '/broking/approval-wording-cv/:idOperation',
  APPROVALWORDING: '/broking/approval-wording/:idOperation',
  ORDERTOBIND: '/broking/order-to-bind/:idOperation',
  STAMPSSTATUSLIST: '/broking/stamps-status-list/:idOperation',
  STAMPSREQUESTCONTACTS: '/broking/stamp-request-contacts/:idOperation',
  SENDORDERTOBIND: '/broking/send-order-to-bind/:idOperation',
  DOCUMENTMANAGEMENT: '/broking/document-management/:idOperation',
  PAYMENTCONFIGURATION: '/broking/payment-pack-configuration/:idOperation/:idOperationParent?',
  SENDINVOICE: '/broking/payment-pack-send-approval/:idOperation',
  SENDPAYMENTPACK: '/broking/payment-pack-send-client-insurer/:idOperation',
  SENDPAYMENTPACKLEGACY: '/broking/payment-pack-send-client-insurer-legacy/:idOperation',
  APPROVALINVOICE: '/broking/payment-pack-approval/:idOperation',
  SENDENDORSEMENTOFFRISK: '/broking/send-endorsement-off-risk/:idOperation',
  APPROVALENDORSEMENTOFFRISK: '/broking/endorsement-off-risk-approval/:idOperation',
  CONTACTSSELECTIONENDORSEMENTOFFRISK: '/broking/endorsement-off-risk-contacts-selection/:idOperation',
  BOUNDENDORSEMENTOFFRISK: '/broking/endorsement-off-risk-bound/:idOperation',
  ENDORSEMENTNOTPREAGREED: '/broking/endorsement-not-pre-agreed/:idOperation',
  ENDORSEMENTCANCELLATION: '/broking/endorsement-cancellation/:idOperation',
  ENDORSEMENTOFFRISK: '/broking/endorsement-off-risk/:idOperation',
  ENDORSEMENTPOLICYEXTENSION: '/broking/endorsement-policy-extension/:idOperation',
  APPROVALENDORSEMENTPOLICYEXTENSION: '/broking/endorsement-policy-extension-approval/:idOperation',
  BOUNDENDORSEMENTPOLICYEXTENSION: '/broking/endorsement-policy-extension-bound/:idOperation',
  ENDORSEMENTMARKETCHANGES: '/broking/endorsement-risk-market-changes/:idOperation',
  ENDORSEMENTADJUSTMENTANDCORRECTIONS: '/broking/adjustments-and-corrections/:idOperation',
  PAYMENTCONFIGURATIONNOTPREAGREED: '/broking/payment-pack-configuration-not-pre-agreed/:idOperation',
  PAYMENTCONFIGURATIONMASTERPOLICY: '/broking/payment-configuration-master-policy/:idOperation',
  PAYMENTPACKMASTERPOLICY: '/broking/payment-pack-master-policy/:idOperation',
  APPROVALINVOICENOTPREAGREED: '/broking/payment-pack-approval-not-pre-agreed/:idOperation',
  CONTACTSSELECTIONNOTPREAGREED: '/broking/contacts-selection-not-pre-agreed/:idOperation',
  SENDINVOICENOTPREAGREED: '/broking/payment-pack-send-approval-not-pre-agreed/:idOperation',
  SENDPAYMENTPACKNOTPREAGREED: '/broking/payment-pack-send-client-insurer-not-pre-agreed/:idOperation',
  PERSONREGISTER: '/save-person/:id?',
  ADJUSTMENTS_CORRECTIONS_EDIT: '/broking/adjustments-and-corrections-edit/:idOperation',
  NOT_PRE_AGREED_EDIT: '/broking/not-pre-agreed-edit/:idOperation',
  CANCELLATION_EDIT: '/broking/cancellation-edit/:idOperation',
  OFF_RISK_EDIT: '/broking/off-risk-edit/:idOperation',
  POLICY_EXTENSION_EDIT: '/broking/policy-extension-edit/:idOperation',
  RISK_MARKET_CHANGES_EDIT: '/broking/risk-and-market-changes-edit/:idOperation',
  SEND_ENDORSEMENT_PACK_MKT_CHANGES: '/broking/send-endorsement-pack-risk-market-changes/:idOperation',
  TESTE: '/broking/teste/:idOperation',
  SENDPOLICYPACKDIRECTORAPPROVAL: '/broking/policy-pack-send-director-approval/:idOperation',
  SENDPOLICYPACKDIRECTOR: '/broking/policy-pack-send-director/:idOperation',
  POLICYPACKDIRECTORAPPROVAL: '/broking/policy-pack-director-approval/:idOperation',
  MANAGEMENT: '/management',
  MANAGEMENT_PERSON: '/management/person/:idPerson?',
  PRODUCT_PLAN_PERSON: '/product-plan/person/:idPerson',
  EDIT_PRODUCT_PLAN: '/product-plan/edit-product-plan/person/:idPerson/:idProduct?/:idProductPlan?',
  PRODUCTS: '/products/person/:idPerson',
  EDIT_PRODUCT: '/products/edit-product/person/:idPerson/:idProduct?',
  NOTIFICATION_PROXY: '/notification-proxy/:idNotification/:idOperation',
  IMPORT_CURRENCY_RATE: '/currency/import-rate',
  CONTRACT_BUILDER: '/broking/contract-builder/:idOperation',
  PAYMENT_PACK_SUMMARY_DISTRIBUTION: '/broking/payment-pack-distribution-summary/:idOperation',
  ENDORSEMENTCLIENTCHANGE: '/broking/endorsement-client-change/:idOperation',
  CLIENT_CHANGE_EDIT: '/broking/client-change-edit/:idOperation',
  SENT_TO_XIS: '/broking/sent-to-xis/:idOperation',
  PROCESS_ADMIN: '/process-admin',
  PROCESS_ADMIN_PERSON: '/process-admin/person/:idPerson?'
};

export default Routes;
